<template>
  <div class="Fuell-Card Fuell-Card--integration" @click="goToIntegrationDetail">
    <div class="Thumb Thumb--32">
      <img :src="getErpIcon(integrationData.integrationOfficeConfigKey)" :alt="integrationData.integrationName">
    </div>
    <div class="Fuell-Card--integration-title ml-3">
      <span>{{integrationData.integrationName}}</span>
    </div>

  </div>
</template>

<script>
import { erpIcons } from '../../_utils/IntegrationsConfigData'
export default {

  name: 'IntegrationCardBox',
  props: {
    integrationData: {
      type: Object,
      required: true
    },
    integrationConfigKey: {
      type: String
    }
  },
  computed: {
    erpIcons () {
      return erpIcons
    }
  },

  methods: {
    goToIntegrationDetail () {
      // this.$router.push(`/company/integrations/${this.integrationData.integrationName}`)
      const erp = this.integrationData.integrationName
      this.$router.push({ name: 'integration_detail', params: { erp } })
    },
    getErpIcon (erpConfigKey) {
      const { integrationIcon } = this.erpIcons.find(el => el.integrationKey === this.integrationData.integrationOfficeConfigKey)
      return integrationIcon || null
    }
  }

}
</script>
